import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface UpdateEventExtra {
	uriParams: Api.Operations['updateEventExtra']['parameters']['path']
	body: NonNullable<
		Api.Operations['updateEventExtra']['requestBody']
	>['content']['application/json']
	response: Api.Operations['updateEventExtra']['responses']['200']['content']['application/json']
}

export const updateEventExtra = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<UpdateEventExtra>(
		{
			method: 'patch',
			url: '/events/{eventId}/extras/{extraId}',
			...overideConfig,
		},
		axiosInstance,
	)
